@let fontColor = corporateDesignService.isDarkModeActive() ? '#FFF' : '';
@let corporateDesign = corporateDesignService.corporateDesign();
<div (click)="cancel()" class="min-w-[300px]">
  <div
    class="absolute top-0 right-0 bottom-0 left-0 z-10 flex flex-row items-center justify-center bg-black/25">
    <div
      tabindex="0"
      [ngStyle]="{
        width: width(),
        maxHeight: '96vh',
        borderRadius: corporateDesignService.borderRadius(),
        borderColor: corporateDesignService.primaryBorderColor(),
        backgroundColor: corporateDesignService.isDarkModeActive()
          ? corporateDesign.colorAdmixtures.dark_surface_01
          : '#FFFFFF',
        color: fontColor,
      }"
      class="border-standard-outline-light relative flex flex-col rounded-xl border-1 sm:w-full"
      (click)="$event.stopPropagation()">
      <div class="flex shrink-0 flex-row items-start justify-between p-6">
        <div class="flex items-start">
          @if (icon()) {
            <div
              [ngStyle]="{ backgroundColor: iconBackgroundColor() }"
              class="mr-2 flex h-7 w-7 items-center justify-center rounded-2xl">
              <span
                class="material-symbols-rounded"
                [style.font-size]="fontSize()"
                [attr.data-testid]="'dialog-title-icon'">
                {{ icon() }}
              </span>
            </div>
          }
          <div class="flex min-w-0 flex-col">
            <span
              class="text-2xl font-semibold"
              [style.font-size]="fontSize()"
              [attr.aria-label]="title()"
              [attr.data-testid]="title()">
              {{ title() }}
            </span>
            @if (subtitle()) {
              <span
                class="text-standard-text-secondary mt-1 text-lg font-normal"
                [attr.data-testid]="'dialog-subtitle'">
                {{ subtitle() }}
              </span>
            }
          </div>
        </div>
        <span
          [style.color]="closingColor()"
          class="material-symbols-rounded cursor-pointer !text-3xl"
          (click)="cancel()"
          [attr.data-testid]="'close-dialog-icon'">
          close
        </span>
      </div>
      @if (content()) {
        <div class="flex-grow overflow-y-auto p-6">
          <ng-container *ngTemplateOutlet="content()!"></ng-container>
        </div>
      }
      <div class="flex shrink-0 flex-row p-6">
        @if (!footer()) {
          @if (isSaveDialog()) {
            <aw-button
              [id]="'save'"
              [type]="'button'"
              (click)="save()"
              [text]="cmsTextProvider.shared.keep"
              class="mr-3 w-full" />
          }
          <aw-button
            [id]="'confirm'"
            [type]="'button'"
            [isDisabled]="!isValid()"
            (click)="submit()"
            [text]="cmsTextProvider.shared.continue"
            class="mr-3 w-full" />
          <aw-button
            class="w-full"
            [id]="'cancel'"
            [type]="'button'"
            (click)="cancel()"
            [style]="'primary-alt'"
            [text]="cmsTextProvider.shared.cancel" />
        } @else {
          <ng-container>
            <ng-container *ngTemplateOutlet="footer()!"></ng-container>
          </ng-container>
        }
      </div>
    </div>
  </div>
</div>
